import React from 'react'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Checkbox } from '@material-ui/core'
import { isUndefined } from 'lodash'
import { checkBoxGrey, primaryRed } from 'styles/variables'

const useStyles = makeStyles({
  primaryColor: { color: `${primaryRed}!important` },
  greyColor: { color: checkBoxGrey },
  differentValue: { color: 'rgb(33,187,58)!important' }
})

export const PrimaryCheckbox = ({ diffValue, indeterminate, ...props }) => {
  const classes = useStyles()
  const className = isUndefined(diffValue) ? ((props.checked && !props.disabled) ? classes.primaryColor : classes.greyColor) : classes.differentValue
  return <Checkbox className={className}
                   indeterminate={indeterminate}
                   indeterminateIcon={<IndeterminateCheckBoxIcon className={props.disabled ? classes.greyColor : classes.primaryColor}/>}
                   {...props} />
}

